const BACKEND_URL = window.__NODE_ENV === 'production' ? '' : 'http://localhost:5003';
const GSHEET_URL = BACKEND_URL + '/gsheet';


const ALL_GENES = Object.freeze([
  'PR', 'RT', 'IN', 'CA'
]);

const GENE_SIZES = Object.freeze({
  PR: 99,
  RT: 560,
  IN: 288,
  CA: 231,
});

/*const WILDTYPES = Object.freeze({
  PR: (
    'PQITLWQRPLVTIKIGGQLKEALLDTGADDTVLEEMNLPGRWKPKMIGGI' +
    'GGFIKVRQYDQILIEICGHKAIGTVLVGPTPVNIIGRNLLTQIGCTLNF'
  ),
  RT: (
    'PISPIETVPVKLKPGMDGPKVKQWPLTEEKIKALVEICTEMEKEGKISKI' +
    'GPENPYNTPVFAIKKKDSTKWRKLVDFRELNKRTQDFWEVQLGIPHPAGL' +
    'KKKKSVTVLDVGDAYFSVPLDKDFRKYTAFTIPSINNETPGIRYQYNVLP' +
    'QGWKGSPAIFQSSMTKILEPFRKQNPDIVIYQYMDDLYVGSDLEIGQHRT' +
    'KIEELRQHLLRWGFTTPDKKHQKEPPFLWMGYELHPDKWTVQPIVLPEKD' +
    'SWTVNDIQKLVGKLNWASQIYAGIKVKQLCKLLRGTKALTEVIPLTEEAE' +
    'LELAENREILKEPVHGVYYDPSKDLIAEIQKQGQGQWTYQIYQEPFKNLK' +
    'TGKYARMRGAHTNDVKQLTEAVQKIATESIVIWGKTPKFKLPIQKETWEA' +
    'WWTEYWQATWIPEWEFVNTPPLVKLWYQLEKEPIVGAETFYVDGAANRET' +
    'KLGKAGYVTDRGRQKVVSLTDTTNQKTELQAIHLALQDSGLEVNIVTDSQ' +
    'YALGIIQAQPDKSESELVSQIIEQLIKKEKVYLAWVPAHKGIGGNEQVDK' +
    'LVSAGIRKVL'
  ),
  IN: (
    'FLDGIDKAQEEHEKYHSNWRAMASDFNLPPVVAKEIVASCDKCQLKGEAM' +
    'HGQVDCSPGIWQLDCTHLEGKIILVAVHVASGYIEAEVIPAETGQETAYF' +
    'LLKLAGRWPVKTIHTDNGSNFTSTTVKAACWWAGIKQEFGIPYNPQSQGV' +
    'VESMNKELKKIIGQVRDQAEHLKTAVQMAVFIHNFKRKGGIGGYSAGERI' +
    'VDIIATDIQTKELQKQITKIQNFRVYYRDSRDPLWKGPAKLLWKGEGAVV' +
    'IQDNSDIKVVPRRKAKIIRDYGKQMAGDDCVASRQDED'
  )
});*/

const AWS_SIGNED_URL = 'https://vutbwdkhc3.execute-api.us-west-1.amazonaws.com/default/mangabey-signed-url';

const NCBI_APIKEY = 'c589b6589a876ae42089c059c49249722807';

const SIERRA_URL = 'https://hivdb.stanford.edu/graphql';
const SIERRA_HIV2_URL = 'https://hivdb.stanford.edu/hiv2/graphql';
// const SIERRA_HIV2_URL = 'https://staging.hivdb.org/hiv2/graphql';

// const SIERRA_URL = 'http://devnext3:8115/WebApplications/rest/graphql';
// const SIERRA_URL = 'http://localhost:8111/WebApplications/rest/graphql';

const PARENTSTRAINS = Object.freeze([
  'CONB',
  'HXB2',
  'LAI',
  'NL43',
  'NCI',
  'p97',
  'pIndieC',
  'MJ4',
  'ROD',
  'EHO',
]);


const PHENOTYPE_METHOD = Object.freeze([
  'PhenoSense',
  'HeLa-CD4 reporter gene',
  'Antivirogram',
  'ANRS',
  'Biochemical',
  'Cell line',
  'Cell protection',
  'Gilead-MT2-Reporter',
  'Gilead-RevLucGFP',
  'HeLaCD4-Canducci',
  'HeLaCD4-ViiV',
  'MAGIC-5A single-cycle',
  'Merck',
  'MT2/MT4 reporter gene',
  'MT4-LTR-EGFP',
  'NCI',
  'PBMC',
  'PBMC-McGill',
  'Phenoscript',
  'Plaque reduction',
  'Single-Cycle',
  'TZM-McGill',
  'TZM-Nagoya',
  'TZM-Sienna',
  'TZM-Milan',
  'TZM-bl',
  'Subtype C Pseudovirus'
]);

const IC_VALUES = Object.freeze([
  '50',
  '90',
]);

const NRTI = Object.freeze([
  'ABC',
  'AZT',
  'D4T',
  'DDI',
  'FTC',
  '3TC',
  'TDF',
  'TAF',
  'ISL',
]);

const NNRTI = Object.freeze([
  'DOR',
  'EFV',
  'ETR',
  'NVP',
  'RPV',
  'DPV'
]);

const NRTI_NNRTI = NRTI.concat(NNRTI);

const PI = Object.freeze([
  'ATV',
  'DRV',
  'FPV',
  'IDV',
  'LPV',
  'NFV',
  'SQV',
  'TPV',
]);

const INSTI = Object.freeze([
  'CAB',
  'BIC',
  'DTG',
  'EVG',
  'RAL',
]);

const CAI = Object.freeze([
  'LEN',
  'GS-CA1',
]);

const HIV_SPECIES = Object.freeze([
  'HIV1',
  'HIV2',
  // 'NHPL',
]);

export {
  BACKEND_URL, GSHEET_URL,
  ALL_GENES, GENE_SIZES, HIV_SPECIES,
  /*WILDTYPES, */
  NCBI_APIKEY, AWS_SIGNED_URL,
  SIERRA_URL, PARENTSTRAINS, SIERRA_HIV2_URL,
  PHENOTYPE_METHOD, IC_VALUES,
  NRTI_NNRTI, PI, INSTI, CAI,
};



// WEBPACK FOOTER //
// ./src/constants.js